export default "__VITE_ASSET__2b7c3f55__"